
<template>
  <!--新增投诉原因-->
  <x-addEdit
    apiOrigin="PHP"
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, addEdit],
  name: 'addReason',
  data () {
    return {
      formList: [
        {
          label: '投诉原因',
          inputType: 'input',
          options: [],
          placeholder: '请输入投诉原因',
          props: ['title', {
            rules: [
              { min: 1, max: 20, message: '投诉原因不超过20个字' },
              { required: true, message: '请输入投诉原因' }
            ]
          }]
        },
        {
          label: '应用位置',
          inputType: 'select',
          options: [],
          placeholder: '请选择应用位置',
          handle: this.reasonTypeChange,
          props: ['type', {
            rules: [{ required: true, message: '请选择应用位置' }]
          }]
        },
        {
          label: '上级原因',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择上级原因',
          props: ['parent_id', { rules: [] }]
        }
      ],
      formKey: {
        title: undefined,
        type: undefined,
        parent_id: undefined
      },
      addParam: {
        url: '/chat/category/complaint',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/chat/category/complaint/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/chat/category/complaint/',
        resHandle: this.resHandle
      }
    };
  },
  created () {
    let query = this.$route.query;
    if (query.id) {
      this.formList[1].disabled = true;
    }
    if (query.parentId && query.type) {
      this.formList[1].disabled = true;
      this.formList[2].disabled = true;
    }
    this.getSelect();
  },
  mounted () {
    this.addChild();
  },
  methods: {
    addChild () {
      let query = this.$route.query;
      if (query.parentId && query.type) {
        this.$refs.addEdit.form.setFieldsValue({
          type: query.type,
          parent_id: query.parentId
        });
        this.getSelect(query.type);
      }
    },
    /* 获取下拉 */
    getSelect (reasonType, level) {
      this._get({
        url: '/chat/category/complaint_select',
        params: {
          type: reasonType,
          level: level
        }
      }).then(({data}) => {
        this.formList[1].options = data.type;
        this.formList[2].options = data.parent;
      });
    },
    /** 选择应用位置事件 */
    reasonTypeChange (e) {
      this.$refs.addEdit.form.resetFields(['parent_id']);
      this.getSelect(e);
    },
    resHandle (res) {
      this.getSelect(res.type, res.level);
      return {};
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
